import { Link } from 'react-router-dom';

const programLinks = [
  { label: 'Vocational Skills Training', path: '/services' },
  { label: 'Job Readiness & Career Development', path: '/services' },
  { label: 'Life Skills Development', path: '/services' },
  { label: 'Employment Placement Support', path: '/services' },
  { label: 'Community Reintegration', path: '/services' },
  { label: 'Workforce Development Training', path: '/services' },
];

const quickLinks = [
  { label: 'Home', path: '/' },
  { label: 'Programs', path: '/services' },
  { label: 'About Us', path: '/about' },
  { label: 'Location', path: '/location' },
  { label: 'Contact', path: '/contact' },
];

const Footer = () => (
  <footer style={{ backgroundColor: '#0f1117' }} className="text-white">
    {/* CTA Banner */}
    <div className="bg-gold">
      <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-playfair text-charcoal font-bold text-lg">
          Ready to start your training? Enrollment is open.
        </p>
        <div className="flex items-center gap-4">
          <a
            href="tel:4698535038"
            className="flex items-center gap-2 text-charcoal font-inter font-semibold text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill" />
            469-853-5038
          </a>
          <Link
            to="/contact"
            className="bg-charcoal text-white font-inter font-bold text-sm px-5 py-2.5 rounded-md whitespace-nowrap cursor-pointer"
          >
            Enroll Now
          </Link>
        </div>
      </div>
    </div>

    {/* Main Footer */}
    <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
      {/* Brand */}
      <div className="lg:col-span-1 flex flex-col gap-5">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 flex items-center justify-center bg-gold rounded-md shrink-0">
            <span className="font-playfair font-bold text-charcoal text-sm">OC</span>
          </div>
          <div>
            <span className="font-playfair font-bold text-xl text-white">OST-C</span>
            <p className="text-gold text-[9px] font-inter font-medium tracking-[0.18em] uppercase">
              Occupational Skills Training
            </p>
          </div>
        </div>
        <p className="font-inter text-sm text-white/55 leading-relaxed">
          Occupational Skills Training Center empowers individuals with the vocational training, life skills, and job readiness needed for lasting employment and independence.
        </p>
        <div className="flex flex-col gap-3 mt-1">
          <a href="tel:4698535038" className="flex items-center gap-3 text-white/65 hover:text-gold transition-colors duration-200 cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center bg-gold/10 rounded-md">
              <i className="ri-phone-line text-gold text-sm" />
            </div>
            <span className="font-inter text-sm">469-853-5038</span>
          </a>
          <div className="flex items-start gap-3 text-white/65">
            <div className="w-8 h-8 flex items-center justify-center bg-gold/10 rounded-md shrink-0 mt-0.5">
              <i className="ri-map-pin-line text-gold text-sm" />
            </div>
            <span className="font-inter text-sm leading-relaxed">Arlington, TX 76006</span>
          </div>
        </div>
      </div>

      {/* Quick Links */}
      <div>
        <h4 className="font-inter font-semibold text-xs tracking-widest uppercase text-gold mb-5">
          Quick Links
        </h4>
        <ul className="flex flex-col gap-3">
          {quickLinks.map((link) => (
            <li key={link.path}>
              <Link
                to={link.path}
                className="font-inter text-sm text-white/55 hover:text-gold transition-colors duration-200 cursor-pointer"
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Programs */}
      <div>
        <h4 className="font-inter font-semibold text-xs tracking-widest uppercase text-gold mb-5">
          Our Programs
        </h4>
        <ul className="flex flex-col gap-3">
          {programLinks.map((s) => (
            <li key={s.label}>
              <Link
                to={s.path}
                className="font-inter text-sm text-white/55 hover:text-gold transition-colors duration-200 cursor-pointer"
              >
                {s.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Map */}
      <div>
        <h4 className="font-inter font-semibold text-xs tracking-widest uppercase text-gold mb-5">
          Find Us
        </h4>
        <div className="w-full h-[180px] rounded-lg overflow-hidden">
          <iframe
            title="OST-C Location - Arlington TX"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d107038.13156764076!2d-97.24817845!3d32.71372745!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e7d1b6bd80635%3A0x2cfaf5d5ef36e0c0!2sArlington%2C%20TX!5e0!3m2!1sen!2sus!4v1712000000000"
            width="100%"
            height="100%"
            style={{ border: 0, filter: 'grayscale(80%) contrast(1.1)' }}
            allowFullScreen
            loading="lazy"
          />
        </div>
        <p className="font-inter text-xs text-white/35 mt-3">
          Serving Arlington, Fort Worth, Grand Prairie &amp; surrounding DFW communities.
        </p>
      </div>
    </div>

    {/* Bottom Bar */}
    <div className="border-t border-white/10 py-5">
      <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="font-inter text-xs text-white/35">
          &copy; 2026 Occupational Skills Training Center (OST-C) &bull; All Rights Reserved
        </p>
        <p className="font-inter text-xs text-white/25">
          Arlington, TX 76006 &bull; 469-853-5038
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
